import { RuntimeConfig } from '../models/runtime-config.model';

const RUNTIME_CONFIG_KEY = 'APP_RUNTIME_CONFIG';

export function runtimeConfig(): RuntimeConfig {
  return <RuntimeConfig>window[RUNTIME_CONFIG_KEY];
}
